<template>
  <BusinessEdit :canEdit="false" />
</template>

<script>
import BusinessEdit from '../components/BusinessEdit.vue';

export default {
  name: 'Listing',
  components: {
    BusinessEdit,
  },
};
</script>
